import { Navigate } from "react-router-dom";

export default function DeliveriesReportRedirect() {
  return <Navigate to="/reports/deliveries/trend" replace />;
}
